"use strict";
exports.__esModule = true;
exports.PARTITION = void 0;
var PARTITION;
(function (PARTITION) {
    PARTITION["UNDEFINED"] = "undefined";
    PARTITION["ADS_MANAGER"] = "ads_manager";
    PARTITION["BUSINESS_MANAGER"] = "business_manager";
    PARTITION["PROFILE_MANAGER"] = "profile_manager";
    PARTITION["REVIEW_TOOL"] = "review_tool";
    PARTITION["SNAP_MAPS"] = "snap_maps";
    PARTITION["FOR_BUSINESS"] = "for_business";
    PARTITION["ADFORMATS_WEB"] = "adformats_web";
    PARTITION["DISCOVER_CMS"] = "discover_cms";
    PARTITION["SNAP_WEB"] = "snap_web";
    PARTITION["NEWSROOM"] = "newsroom";
    PARTITION["YELLOW_LA"] = "yellow_la";
    PARTITION["CITIZEN_SNAP"] = "citizen_snap";
    PARTITION["SNAP_FOUNDATION"] = "snap_foundation";
    PARTITION["ENG_BLOG"] = "eng_blog";
    PARTITION["RESEARCH_SNAP"] = "research_snap";
    PARTITION["MY_LENSES"] = "my_lenses";
    PARTITION["PLAYCANVAS"] = "playcanvas";
    PARTITION["MEASUREMENT_PORTAL"] = "measurement_portal";
    PARTITION["TRUST"] = "trust";
    PARTITION["CHEERIOS"] = "cheerios";
    PARTITION["SPS"] = "sps";
    PARTITION["AR_SNAP"] = "ar_snap";
    PARTITION["DEVELOPER_SNAP"] = "developer_snap";
    PARTITION["DANDELION"] = "dandelion";
    PARTITION["CREATORS_SNAP"] = "creators_snap";
    PARTITION["DIVERSITY"] = "diversity";
    PARTITION["SNAPCHAT_WEB"] = "snapchat_web";
    PARTITION["EMBEDDED_WEBVIEW_ADS"] = "embedded_webview_ads";
    PARTITION["METRICS_MONITOR"] = "metrics_monitor";
    PARTITION["SNAPGRAPH"] = "snapgraph";
    PARTITION["MEASUREMENT_RESONANCE_SURVEY"] = "measurement_resonance_survey";
    PARTITION["MEASUREMENT_MR_SURVEY"] = "measurement_mr_survey";
    PARTITION["MEASUREMENT_COLLECTION_SURVEY"] = "measurement_collection_survey";
    PARTITION["STORY_STUDIO_LITE"] = "story_studio_lite";
    PARTITION["WEB_SELF_SERVE_ADS"] = "web_self_serve_ads";
    PARTITION["ARCADIA"] = "arcadia";
    PARTITION["SNAP_523"] = "snap_523";
    PARTITION["ORIGINALS"] = "originals";
    PARTITION["LEO_WEB"] = "leo_web";
    PARTITION["DWEB"] = "dweb";
    PARTITION["SCN_CONTENT_MANAGER"] = "scn_content_manager";
    PARTITION["ADVERTISER_360"] = "advertiser_360";
    PARTITION["CAREERS"] = "careers";
    PARTITION["PRIVACY_INFRA"] = "privacy_infra";
    PARTITION["BLIZZARD"] = "blizzard";
    PARTITION["COOKIE_MODAL_COMPONENTS"] = "cookie_modal_components";
    PARTITION["CONTENT_TOOLS"] = "content_tools";
    PARTITION["WEB_ACCOUNTS"] = "web_accounts";
    PARTITION["MARKETING_WEB_PLATFORM"] = "marketing_web_platform";
    PARTITION["ARES_SDK"] = "ares_sdk";
    PARTITION["SNAP_ORCA"] = "snap_orca";
})(PARTITION = exports.PARTITION || (exports.PARTITION = {}));
exports["default"] = PARTITION;
//# sourceMappingURL=partition.js.map